
import {
    IS_LOADING_START,
    IS_LOADING_STOP,
    GET_LIST_ALL_TASK_SUCCESS

} from "./Types";


// notify
import { notify } from "../../components/common/Toaster";

// api services
import { _addTask, _getTaskList } from "../../config/api/TaskServices";

// url
import Url from "../../config/env/BaseUrl";
import { _Api } from "../../config/api/Api";



// get tag list
export const getAllTaskList = req => dispatch => {
    dispatch({ type: IS_LOADING_START })
    _Api(Url.ADMIN_GET_TASK.method, Url.ADMIN_GET_TASK.url, req)
        .then(resp => {
            let payload = {
                taskInfo: resp.responseData
            }
            dispatch({ type: GET_LIST_ALL_TASK_SUCCESS, payload })
            dispatch({ type: IS_LOADING_STOP })

        }).catch(err => {
            dispatch({ type: IS_LOADING_STOP })

        })
}

// add new tag
export const addNewTask = (req, req2) => dispatch => {
    dispatch({ type: IS_LOADING_START })
    _Api(Url.ADMIN_ADD_TASK.method, Url.ADMIN_ADD_TASK.url, req)
        .then(resp => {
            getAllTaskList(req2)(dispatch)
            dispatch({ type: IS_LOADING_STOP })
            setTimeout(() => { notify("success", resp.responseData.message) }, 300)
        }).catch(err => {
            dispatch({ type: IS_LOADING_STOP })
            if (err.error)
                notify("err", err.error.message)
            else if (err)
                notify("err", err.message)

        })

}
